// @flow
import shortId from 'shortid'
import store from '../../store'
import type { ValidatedAdvertisementWithStoredMedia } from '../../../components/types'
import type { ErrorsPack } from '../../../components/initErrorsFromResponse'
import * as advertisementActions from './reducers'
import * as carouselOperations from '../carouselEdit/operations'
import { getAdvertisement } from '../../selectors'

function putErrors(storeId: string, errors: ErrorsPack) {
  const advertisement = getAdvertisement(store.getState(), storeId)
  store.dispatch(
    advertisementActions.patch(storeId, { ...errors.commonErrors, ...errors.mediaErrors })
  )
  const carouselStoreId = advertisement.carouselStoreId
  if (carouselStoreId) {
    carouselOperations.putErrors(carouselStoreId, errors.carouselErrors)
  }
}

function putAdvertisement(advertisement: ValidatedAdvertisementWithStoredMedia): string {
  const storeId = shortId.generate()
  store.dispatch(advertisementActions.put(storeId, advertisement))
  return storeId
}

const put = advertisementActions.put

export { put, putAdvertisement, putErrors }
